export default __webpack_public_path__ + "static/media/node.a1176648.PNG";